// extracted by mini-css-extract-plugin
export var capsule = "capsule-module--capsule--4b08f";
export var selected = "capsule-module--selected--1c8ab";